var ngMenu = angular.module('ng.navigation', []);
ngMenu.directive('angularMenu', [
    'preLoadedData',
    '$state',
    '$timeout',
    function (preLoadedData, $state, $timeout) {
        return {
            restrict: 'E',
            templateUrl: 'views/templates/left_menu/menu.html',
            replace: true,
            compile: function (menuWrapper) {
                return function ($scope) {
                    //angular.copy(preLoadedData.data.menu);
                    $scope.menuItems = [
                        /* {
                         state: "main.dashboard",
                         label: "left_menu.dashboard",
                         cssClass: "dashBoard"
                         },*/
                        {
                            state: "main.skins",
                            label: "left_menu.skins.label",
                            cssClass: "skin",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.skins.add",
                                    label: "left_menu.skins.add",
                                    cssClass: "addSkin"
                                },
                                {
                                    state: "main.skins.list",
                                    label: "left_menu.skins.list",
                                    cssClass: "allSkins"
                                }
                            ]
                        },
                        {
                            state: "main.media",
                            label: "left_menu.media.label",
                            cssClass: "media",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.media.add",
                                    label: "left_menu.media.add",
                                    cssClass: "addMedia"
                                },
                                {
                                    state: "main.media.list",
                                    label: "left_menu.media.list",
                                    cssClass: "allMedias"
                                }
                            ]
                        },
                        {
                            state: "main.popups",
                            label: "left_menu.popups.label",
                            cssClass: "popups",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.popups.add",
                                    label: "left_menu.popups.add",
                                    cssClass: "addPopup"
                                },
                                {
                                    state: "main.popups.list",
                                    label: "left_menu.popups.list",
                                    cssClass: "allPopups"
                                }
                            ]
                        },
                        {
                            state: "main.users",
                            label: "left_menu.users.label",
                            cssClass: "users",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.users.add",
                                    label: "left_menu.users.add",
                                    cssClass: "addUser"
                                },
                                {
                                    state: "main.users.list",
                                    label: "left_menu.users.list",
                                    cssClass: "allUsers"
                                }
                            ]
                        },
                        {
                            state: "pages",
                            label: "left_menu.pages.label",
                            cssClass: "blocks",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.pages.add",
                                    label: "left_menu.pages.add",
                                    cssClass: "addBlock"
                                },
                                {
                                    state: "main.pages.list",
                                    label: "left_menu.pages.list",
                                    abstract: true,
                                    cssClass: "blocksList",
                                    subMenu : [
                                        {
                                            state: "main.pages.list.banners",
                                            label: "left_menu.pages.List.banners",
                                            cssClass: "blocksAllBanners allBanners"
                                        },
                                        {
                                            state: "main.pages.list.categories",
                                            label: "left_menu.pages.List.categories",
                                            cssClass: "blocksAllCategories"
                                        },
                                        {
                                            state: "main.pages.list.news",
                                            label: "left_menu.pages.List.news",
                                            cssClass: "blocksAllNews allNews"
                                        },
                                        {
                                            state: "main.pages.list.texts",
                                            label: "left_menu.pages.List.texts",
                                            cssClass: "blocksAllTexts allText"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            state: "main.configs",
                            label: "left_menu.configs",
                            closeMain: true,
                            cssClass: "configs"
                        },
                        {
                            state: "main.styles",
                            label: "left_menu.styles",
                            closeMain: true,
                            cssClass: "styles"
                        },
                        {
                            state: "main.reset",
                            label: "left_menu.skins.reset",
                            cssClass: "reset"
                        },



                        {
                            state: "main.providers",
                            label: "left_menu.providers.label",
                            cssClass: "provider",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.providers.add",
                                    label: "left_menu.providers.add",
                                    cssClass: "addProvider"
                                },
                                {
                                    state: "main.providers.list",
                                    label: "left_menu.providers.list",
                                    cssClass: "allProviders"
                                }
                            ]
                        },
                        {
                            state: "main.categories",
                            label: "left_menu.categories.label",
                            cssClass: "category",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.categories.add",
                                    label: "left_menu.categories.add",
                                    cssClass: "addCategory"
                                },
                                {
                                    state: "main.categories.list",
                                    label: "left_menu.categories.list",
                                    cssClass: "allCategories"
                                }
                            ]
                        },
                        {
                            state: "main.games",
                            label: "left_menu.games.label",
                            cssClass: "game",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.games.add",
                                    label: "left_menu.games.add",
                                    cssClass: "addGame"
                                },
                                {
                                    state: "main.games.list",
                                    label: "left_menu.games.list",
                                    cssClass: "allGames"
                                }
                            ]
                        },
                        {
                            state: "main.casinoGames",
                            label: "left_menu.casinoGames.label",
                            cssClass: "casinoGame",
                            abstract: true,
                            subMenu: [
                                {
                                    state: "main.casinoGames.list",
                                    label: "left_menu.casinoGames.list",
                                    cssClass: "allCasinoGames"
                                },
                                {
                                    state: "main.hiddenGames",
                                    label: "left_menu.hiddenGames.label",
                                    cssClass: "hiddenGamesGroup"
                                }
                            ]
                        }
                    ];
                    var currentActive;
                    $timeout(function () {
                        $(menuWrapper).find("a").on("click", function () {
                            if (!!$(this).attr("ui-sref")) {
                                if (!!currentActive && !currentActive.not($(this).closest(".menuItem")).length) {
                                    if ($(this).parent("li").hasClass("active")) {
                                        return
                                    } else {
                                        /*
                                        use this to close other sub menus
                                        if ($(this).parent("li").not(currentActive.find("a[ui-sref].active").parent("li"))) {
                                            currentActive.find(".active").not(currentActive.children("a").add($(this).parent()).add($(this)).add($(this).parent().parent().closest("li"))).toggleClass("active")
                                        } else {
                                            currentActive.find("a[ui-sref].active").toggleClass("active").parent("li").toggleClass("active")
                                        }*/
                                        currentActive.find("a[ui-sref].active").toggleClass("active").parent("li").toggleClass("active")
                                    }
                                } else {
                                    currentActive && currentActive.find(".active").removeClass("active");
                                    currentActive = $(this).closest(".menuItem");
                                    currentActive.children("a").toggleClass("active");
                                }
                                $(this).not(currentActive.children("a")).parent("li").add($(this).not(currentActive.children("a"))).toggleClass("active");
                            } else {
                                $(this).parent("li").add(!$(this).parent("li").hasClass("menuItem") && $(this)).toggleClass("active")
                            }
                        });
                        getOpenedMenuItem();
                    });

                    function getOpenedMenuItem () {
                        var currentState = $state.$current.name;
                        $(menuWrapper).find("a").each(function () {
                            if ($(this).attr("ui-sref") === currentState) {
                                if (currentState == "main.configs" || currentState == "main.styles") {
                                    $("body").addClass("minimized_left_menu");
                                    $scope.$digest($scope.menu_switcher = true);
                                }
                                return $(this).click();
                            }
                        })
                    }

                    $scope.$watch("menu_switcher", function (newVal, oldVal) {
                        if (newVal !== oldVal && !!newVal) {
                            $("body").addClass("minimized_left_menu");
                        } else {
                            $("body").removeClass("minimized_left_menu");
                        }
                    });

                    $scope.rendered = function () {
                        $scope.$broadcast("menu:rendered")
                    }

                }
            }
        }
    }
]).directive('menu', [
    '$timeout',
    '$state',
    function ($timeout, $state) {
        return {
            restrict: 'E',
            templateUrl: function () {
                if ($state.current.name !== "main.configs") {
                    return 'views/templates/styles_menu/menu.html'
                }
                return 'views/templates/configs_menu/menu.html'
            },
            replace: true,
            link: function (scope, menuWrapper) {
                menuWrapper = $(menuWrapper);
                $timeout(function () {
                    $(menuWrapper).find("li").on("click", function (e) {
                        if ($(this).find("form:visible").length) {
                            return
                        }
                        var other_active_menu = menuWrapper.find("li.active.menu_item").length && menuWrapper.find("li.active.menu_item").not($(this));
                        if ($(this).hasClass("menu_item") && other_active_menu && other_active_menu.length) {
                            other_active_menu.toggleClass("active");
                            other_active_menu.find(".active").toggleClass("active");
                        }
                        $(this).parent().find(".active").not($(this)).toggleClass("active");
                        if ($(this).find("ul").length) {
                            $(this).find(".active").toggleClass("active");
                            if (scope.configData && scope.configData.configSkinId && $(this).find("ul").find("[config-skin-id='" + scope.configData.configSkinId + "']").length) {
                                $(this).find("ul").find("[config-skin-id='" + scope.configData.configSkinId + "']").addClass("active");
                            }
                            $(this).toggleClass("active")
                        } else {
                            $(this).toggleClass("active");
                        }
                    });
                });
            }
        }
    }
]);